import { Component, OnInit, Input } from "@angular/core";
import { MTracingItem } from "../../models/tracing-item-model";
import { MReportType } from "../../models/report-type.model";
import { SieniService } from "../../services/sieni.service";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { ReportService } from "../../services/report.service";
import { LoadingService } from "src/app/shared/components";

@Component({
  selector: "history-item",
  templateUrl: "./history-item.component.html",
  styleUrls: ["./history-item.component.scss"],
})
export class HistoryItemComponent implements OnInit {
  constructor(
    private _globalService: SieniService,
    private translate: TranslateService,
    private reportServices: ReportService,
    private toastr: ToastrService,
    private loading: LoadingService
  ) {
    this.lang = this.translate.defaultLang;
  }

  @Input() public item: MTracingItem = null;
  @Input() public types: MReportType[] = [];
  public typeId: string = "0";
  public receiving: boolean = false;
  public lang: string;
  public generating: boolean = false;

  ngOnInit() {
    this.lang = this.translate.currentLang;
    console.log(this.item);
  }

  public generateReport() {
    this.receiving = true;
    // this.toastr.error(this.translate.instant("historic.error.notAvailable"))
    this.reportServices.reportHistoric(this.item.id).subscribe(
      (res) => {
        var file = new Blob([res], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        this.receiving = false;
      },
      (err) => {
        console.error(err);
        this.receiving = false;
      }
    );
  }
}
